'use strict';

import { CoreRepository } from '../CoreRepository';
import { User } from '../../Entities/User/User';
import { IpList } from '../../Entities/IpList';
import { IpListCollection } from '../../Collections/IpListCollection';

export class UserRepository extends CoreRepository {
  public getUser(userId: number, options: object = {}) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getUser(userId, options).then((response) => {
      const user = new User();
      user.hydrate(response);

      return user;
    });
  }

  public getMe(options: object = {}) {
    if (!options) {
      options = {};
    }

    return this.webAPI.getMe(options).then((response) => {
      const user = new User();
      user.hydrate(response);

      return user;
    });
  }

  public updateUser(payload: any[]) {
    return this.webAPI.updateUser(payload).then((response) => {
      return response;
    });
  }

  public getAuth0SAMLURL() {
    return this.webAPI.getBaseURL() + '/auth0/saml/login';
  }

  public getOAuthURL(provider) {
    return (
      this.webAPI.getBaseURL() +
      '/integrations/oauth/' +
      provider +
      '?accessToken=' +
      this.webAPI.getAccessToken()
    );
  }

  public getAuth0SAMLPayload() {
    return this.webAPI.getAuth0SAMLPayload();
  }

  public getAuth0SAMLIndPayload(indId: number, payload: any) {
    return this.webAPI.getAuth0SAMLIndPayload(indId, payload);
  }

  public getUserIps(userId: number, options: object = {}) {
    return this.webAPI.getUserIps(userId, options).then((response) => {
      const collection = new IpListCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new IpList();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public addUserIp(userId, payload: object = {}) {
    return this.webAPI.addUserIp(userId, payload).then((response) => {
      const ip = new IpList();
      ip.hydrate(response);

      return ip;
    });
  }

  public removeUserIp(userId: number, ipId: number, payload: object = {}) {
    return this.webAPI.removeUserIp(userId, ipId, payload).then((response) => {
      return response;
    });
  }
}
